var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-block" },
    [
      _c(
        "div",
        { staticClass: "lists" },
        _vm._l(_vm.FOOTER_MENU, function(list, i) {
          return _c("list-item", { key: i, attrs: { list: list } })
        }),
        1
      ),
      _c("div", { staticClass: "logo container" }, [
        _c(
          "a",
          { attrs: { href: "/" } },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.IconLogo.id }
            })
          ],
          1
        ),
        _vm._m(0)
      ]),
      _vm._m(1),
      _c("social-networks", { staticClass: "socials container" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Интернет-магазин яркой"),
      _c("br"),
      _vm._v("и доступной одежды для всей семьи")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contacts container" }, [
      _c("div", { staticClass: "title" }, [_vm._v("\n      Контакты\n    ")]),
      _c("span", [_vm._v("8 800 770 01 01")]),
      _vm._v("\n    Мы принимаем звонки c 7:00 до 22:00 (мск)."),
      _c("br"),
      _vm._v("\n    Звонок по России бесплатный.\n    "),
      _c("span", [_vm._v("helpme@fundayshop.com")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }